import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { AuthSelectors } from '@ngrx-store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private store: Store, private router: Router) { }

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(AuthSelectors.isLoggedIn),
      tap(async loggedIn => {
        if (!loggedIn) {
          await this.router.navigate([''], {
            queryParams: { returnUrl: `${window.location.pathname.replace('/', '')}${window.location.search}` },
          });
        }
      }),
    );
  }
}
